import React from 'react';
import { motion } from 'framer-motion';
import { FaAward, FaUsers, FaClock, FaShieldAlt } from 'react-icons/fa';

const reasons = [
  {
    icon: <FaAward className="text-phoenix-gold w-8 h-8" />,
    title: 'Expert Team',
    description: 'Our experienced dentists and staff provide top-quality care with the latest techniques.',
  },
  {
    icon: <FaUsers className="text-phoenix-gold w-8 h-8" />,
    title: 'Patient-Centered Care',
    description: 'We prioritize your comfort and well-being, ensuring a positive dental experience.',
  },
  {
    icon: <FaClock className="text-phoenix-gold w-8 h-8" />,
    title: 'Convenient Hours',
    description: 'Flexible scheduling to fit your busy lifestyle, including evenings and weekends.',
  },
  {
    icon: <FaShieldAlt className="text-phoenix-gold w-8 h-8" />,
    title: 'Advanced Technology',
    description: 'State-of-the-art equipment for accurate diagnoses and effective treatments.',
  },
];

const WhyChooseUs = () => {
  return (
    <section className="bg-phoenix-beige py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.h2
          className="text-3xl font-bold text-phoenix-gold mb-12 text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          Why Choose Phoenix Dental?
        </motion.h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {reasons.map(({ icon, title, description }, index) => (
            <motion.div
              key={index}
              whileHover={{ scale: 1.05 }}
              className="bg-phoenix-white rounded-lg p-6 shadow-md hover:shadow-xl transition-shadow text-center"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="mb-4 flex justify-center">{icon}</div>
              <h3 className="text-xl font-semibold text-phoenix-black mb-2">{title}</h3>
              <p className="text-phoenix-gray">{description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
